/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { APP_VERSION } from "appVersion";

const CacheBuster = props => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log(
      `App is running in ${process.env.REACT_APP_ENVIRONMENT} mode with build number ${process.env.REACT_APP_BUILD_NUMBER} and app version ${APP_VERSION}`
    );

    fetch("/meta.json")
      .then(response => response.json())
      .then(meta => {
        const latestVersion = meta.version;
        const shouldForceRefresh = semverGreaterThan(latestVersion, APP_VERSION);
        if (shouldForceRefresh) {
          refreshCacheAndReload();
        } else {
          console.log(`You already have the latest version ${latestVersion}. No cache refresh needed.`);
        }
        setIsLoading(false);
      });
  }, []);

  const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);
    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
      // const a = Number(versionsA.shift());
      // const b = Number(versionsB.shift());
      const a = versionsA.shift();
      const b = versionsB.shift();
      // eslint-disable-next-line no-continue
      if (a === b) continue;
      // eslint-disable-next-line no-restricted-globals
      return a > b || isNaN(b);
    }
    return false;
  };

  const refreshCacheAndReload = () => {
    if (caches) {
      caches.keys().then(function (names) {
        console.log("Clearing cache:", names);
        for (const name of names) caches.delete(name);
      });
    }
    console.log("Cache cleared, reloading app");
    window.location.reload(true);
  };

  return <>{!isLoading && props.children}</>;
};

export default CacheBuster;
